import Api from '../ui/src/api';
import { getProp } from '../ui/src/utilities';
import moment from 'moment';
import Cookies from 'js-cookie';
import {
  addLoading,
  removeLoading,
  xhrRequest,
  xhrRequestSuccess,
  xhrRequestFailure,
  getSections,
  getSectionArticles,
  fetchStaticText,
} from '../ui/src/actions';
import {
  fetchSectionArticles,
  fetchArticleRelated,
  fetchSections,
  fetchArticles,
} from '../ui/src/csm.service';

export const ACTION = {
  FOOTERMENU_REQUEST: 'FOOTERMENU_REQUEST',
  FOOTERMENU_SUCCESS: 'FOOTERMENU_SUCCESS',
  FOOTERMENU_FAILURE: 'FOOTERMENU_FAILURE',
  CATEGORIES_REQUEST: 'CATEGORIES_REQUEST',
  CATEGORIES_SUCCESS: 'CATEGORIES_SUCCESS',
  CATEGORIES_FAILURE: 'CATEGORIES_FAILURE',

  SEASONMENU_REQUEST: 'SEASONMENU_REQUEST',
  SEASONMENU_SUCCESS: 'SEASONMENU_SUCCESS',
  SEASONMENU_FAILURE: 'SEASONMENU_FAILURE',

  HOME_CATEGORIES: 'HOME_CATEGORIES',
  HOME_LOCATION_ARTICLES: 'HOME_LOCATION_ARTICLES',
  LOCATION_CATEGORIES: 'LOCATION_CATEGORIES',
  PLAYLIST_REQUEST: 'PLAYLIST_REQUEST',
  PLAYLIST_SUCCESS: 'PLAYLIST_SUCCESS',
  PLAYLIST_FAILURE: 'PLAYLIST_FAILURE',
  SECTION_DETAIL_REQUEST: 'SECTION_DETAIL_REQUEST',
  SECTION_DETAIL_SUCCESS: 'SECTION_DETAIL_SUCCESS',
  SECTION_DETAIL_MORE_ARTICLES_SUCCESS: 'SECTION_DETAIL_MORE_ARTICLES_SUCCESS',
  ARTICLE_DETAIL_REQUEST: 'ARTICLE_DETAIL_REQUEST',
  ARTICLE_DETAIL_SUCCESS: 'ARTICLE_DETAIL_SUCCESS',
  MOST_READ_REQUEST: 'MOST_READ_REQUEST',
  MOST_READ_SUCCESS: 'MOST_READ_SUCCESS',
  HOME_TVKOSICE_ARTICLE_REQUEST: 'HOME_TVKOSICE_ARTICLE_REQUEST',
  HOME_TVKOSICE_ARTICLE_SUCCESS: 'HOME_TVKOSICE_ARTICLE_SUCCESS',
  HOME_RADIOKOSICE_ARTICLE_REQUEST: 'HOME_RADIOKOSICE_ARTICLE_REQUEST',
  HOME_RADIOKOSICE_ARTICLE_SUCCESS: 'HOME_RADIOKOSICE_ARTICLE_SUCCESS',
  WEATHER_CREDIT: 'WEATHER_CREDIT',
  GET_USER: 'GET_USER',
  UPDATE_UNREAD_ARTICLES: 'UPDATE_UNREAD_ARTICLES',
  FETCH_CALENDAR_LOCATIONS_SUCCESS: 'FETCH_CALENDAR_LOCATIONS_SUCCESS',
  FETCH_CALENDAR_EVENTS_REQUEST: 'FETCH_CALENDAR_EVENTS_REQUEST',
  FETCH_CALENDAR_EVENTS_SUCCESS: 'FETCH_CALENDAR_EVENTS_SUCCESS',
  FETCH_CALENDAR_EVENTS_FAILURE: 'FETCH_CALENDAR_EVENTS_FAILURE',
  BANNER_FETCH_SUCCESS: 'BANNER_FETCH_SUCCESS',

  ELECTION_STATIC_DATA_REQUEST: 'ELECTION_STATIC_DATA_REQUEST',
  ELECTION_STATIC_DATA_SUCCESS: 'ELECTION_STATIC_DATA_SUCCESS',
  ELECTION_STATIC_DATA_FAILURE: 'ELECTION_STATIC_DATA_FAILURE',
  
  ELECTION_SLOVAKIA_REQUEST: 'ELECTION_SLOVAKIA_REQUEST',
  ELECTION_SLOVAKIA_SUCCESS: 'ELECTION_SLOVAKIA_SUCCESS',
  ELECTION_SLOVAKIA_FAILURE: 'ELECTION_SLOVAKIA_FAILURE',

  ELECTION_REGION_REQUEST: 'ELECTION_REGION_REQUEST',
  ELECTION_REGION_SUCCESS: 'ELECTION_REGION_SUCCESS',
  ELECTION_REGION_FAILURE: 'ELECTION_REGION_FAILURE',

  ELECTION_DISTRICT_REQUEST: 'ELECTION_DISTRICT_REQUEST',
  ELECTION_DISTRICT_SUCCESS: 'ELECTION_DISTRICT_SUCCESS',
  ELECTION_DISTRICT_FAILURE: 'ELECTION_DISTRICT_FAILURE',
};

export const getFootermenu = () => {
  return getSections(
    process.env.REACT_APP_CONTENT_SPACE,
    'FOOTERMENU',
    'footer',
  );
};

export const getVasimiOcami = () => {
  return getSectionArticles(
    process.env.REACT_APP_CONTENT_SPACE,
    'VASIMI_OCAMI',
    'vasimi-ocami',
    {
      limit: 4,
      sorter: 'pin2category',
    },
  );
};

export const fetchHomeCategories = () => {
  return dispatch => {
    dispatch(addLoading());
    return fetchSections(process.env.REACT_APP_CONTENT_SPACE, 'categories')
      .then(response => {
        const promises = [];
        for (let section of getProp(response, 'sections', [])) {
          // fetch articles for each section
          promises.push(
            fetchSectionArticles(
              process.env.REACT_APP_CONTENT_SPACE,
              section._id,
              {
                limit: 4,
                sorter: 'pin2category',
              },
            ),
          );
        }

        const data = {
          sections: [],
        };
        return Promise.all(promises).then(responses => {
          for (let i = 0; i < getProp(response, 'sections', []).length; i++) {
            let section = response.sections[i];
            section['articles'] = responses[i];
            data.sections.push(section);
          }
          dispatch({
            type: ACTION.HOME_CATEGORIES,
            data,
            receivedAt: moment().toISOString(),
          });
          dispatch(removeLoading());
        });
      })
      .catch(error => {
        dispatch(removeLoading());
        throw error;
      });
  };
};

export const fetchLocationCategoryArticles = locationId => {
  return dispatch => {
    dispatch(addLoading());
    return fetchSections(process.env.REACT_APP_CONTENT_SPACE, 'categories')
      .then(response => {
        const promises = [];
        for (let section of getProp(response, 'sections', [])) {
          // fetch articles for each section
          promises.push(
            fetchSectionArticles(
              process.env.REACT_APP_CONTENT_SPACE,
              section._id,
              {
                smarttags: `location:${locationId}`,
                limit: 4,
              },
            ),
          );
        }

        const data = {
          sections: [],
        };
        return Promise.all(promises).then(responses => {
          for (let i = 0; i < response.sections.length; i++) {
            let section = response.sections[i];
            section['articles'] = responses[i];
            data.sections.push(section);
          }
          dispatch({
            type: ACTION.LOCATION_CATEGORIES,
            data,
            receivedAt: moment().toISOString(),
          });
          dispatch(removeLoading());
        });
      })
      .catch(error => {
        dispatch(removeLoading());
      });
  };
};

export const getLocationSmartTags = () => {
  return (dispatch, getStore) => {
    const key = 'LOCATION_SMART_TAGS';
    dispatch(xhrRequest(key));
    dispatch(addLoading());
    return fetchLocationSmartTags()
      .then(response => {
        dispatch(removeLoading());
        dispatch(xhrRequestSuccess(key, response));
        return response;
      })
      .catch(error => {
        dispatch(removeLoading());
        dispatch(
          xhrRequestFailure(key, getProp(error, 'response.status', null)),
        );
        throw error;
      });
  };
};

const fetchLocationSmartTags = () => {
  return Api.get(
    `/cm/public/${process.env.REACT_APP_CONTENT_SPACE}/smart-tags/location`,
  );
};

export const fetchHomeLocationArticles = () => {
  return dispatch => {
    const key = ACTION.HOME_LOCATION_ARTICLES;
    dispatch(xhrRequest(key));
    dispatch(addLoading());
    return dispatch(getLocationSmartTags())
      .then(response => {
        const promises = [];
        for (let value of getProp(response, 'values', [])) {
          // fetch articles for each section
          promises.push(
            fetchArticles(process.env.REACT_APP_CONTENT_SPACE, {
              smarttags: `location:${value.id}`,
              limit: 6,
              sorter: 'pin2locality',
            }),
          );
        }

        const data = {
          values: [],
        };
        return Promise.all(promises).then(responses => {
          for (let i = 0; i < getProp(response, 'values', []).length; i++) {
            let val = response.values[i];
            val['articles'] = responses[i];
            data.values.push(val);
          }
          dispatch({
            type: ACTION.HOME_LOCATION_ARTICLES,
            data,
            receivedAt: moment().toISOString(),
          });
          dispatch(removeLoading());
        });
      })
      .catch(error => {
        dispatch(removeLoading());
        throw error;
      });
  };
};

export const fetchPlaylist = (params = {}) => {
  const type = 'PLAYLIST';
  return dispatch => {
    dispatch(xhrRequest(type));
    return Api.get(`/playlists/radiokosice`, params)
      .then(response => {
        dispatch(xhrRequestSuccess(type, response));
      })
      .catch(error => {
        dispatch(xhrRequestFailure(type));
        throw error;
      });
  };
};

export const fetchArticleDetail = (id, limit = 10) => {
  return dispatch => {
    dispatch(addLoading());
    dispatch({
      type: ACTION.ARTICLE_DETAIL_REQUEST,
      articleId: id,
    });

    return fetchArticleRelated(
      process.env.REACT_APP_CONTENT_SPACE,
      id,
      limit,
    ).then(response => {
      dispatch({
        type: ACTION.ARTICLE_DETAIL_SUCCESS,
        articleId: id,
        articles: response.articles,
      });
      dispatch(removeLoading());
    });
  };
};

export const fetchSectionDetail = (id, locationId) => {
  return dispatch => {
    const articleLimit = 11;
    dispatch(addLoading());
    dispatch({
      type: ACTION.SECTION_DETAIL_REQUEST,
      sectionId: id,
      locationId,
    });
    if (locationId) {
      return Promise.all([
        fetchSectionArticles(process.env.REACT_APP_CONTENT_SPACE, id, {
          smarttags: `location:${locationId}`,
          limit: articleLimit,
          sorter: 'pin2category',
        }),
      ])
        .then(responses => {
          let [articles] = responses;
          dispatch({
            type: ACTION.SECTION_DETAIL_SUCCESS,
            sectionId: id,
            locationId,
            articleOffset: 0,
            data: {
              articles: {
                articles: articles.articles,
                nextOffset: articles.nextOffset,
              },
              locations: [],
            },
          });
          dispatch(removeLoading());
        })
        .catch(e => {
          dispatch(removeLoading());
          throw e;
        });
    } else {
      return Promise.all([
        fetchSectionArticles(process.env.REACT_APP_CONTENT_SPACE, id, {
          limit: articleLimit,
          sorter: 'pin2category',
        }),
        getCategoryLocationArticles(id),
      ])
        .then(responses => {
          let [articles, locations] = responses;
          dispatch({
            type: ACTION.SECTION_DETAIL_SUCCESS,
            sectionId: id,
            locationId: null,
            articleOffset: 0,
            data: {
              articles: {
                articles: articles.articles,
                nextOffset: articles.nextOffset,
              },
              locations: locations,
            },
          });
          dispatch(removeLoading());
        })
        .catch(e => {
          dispatch(removeLoading());
          throw e;
        });
    }
  };
};

export const loadMoreSectionDetailArticles = (id, locationId, offset) => {
  return dispatch => {
    const params = {
      offset,
      limit: 8,
      sorter: 'pin2category',
    };
    if (locationId) {
      params['smarttags'] = `location:${locationId}`;
    }
    return fetchSectionArticles(
      process.env.REACT_APP_CONTENT_SPACE,
      id,
      params,
    ).then(response => {
      dispatch({
        type: ACTION.SECTION_DETAIL_SUCCESS,
        sectionId: id,
        locationId,
        articleOffset: offset,
        data: {
          articles: {
            articles: response.articles,
            nextOffset: response.nextOffset,
          },
        },
      });
    });
  };
};

const getCategoryLocationArticles = sectionId => {
  return new Promise((resolve, reject) => {
    return fetchLocationSmartTags().then(response => {
      const promises = [];
      for (let value of response.values) {
        // fetch articles for each section
        promises.push(
          fetchSectionArticles(process.env.REACT_APP_CONTENT_SPACE, sectionId, {
            smarttags: `location:${value.id}`,
            limit: 4,
          }),
        );
      }

      const data = [];
      return Promise.all(promises).then(responses => {
        for (let i = 0; i < response.values.length; i++) {
          let loc = response.values[i];
          loc['articles'] = responses[i];
          data.push(loc);
        }
        resolve(data);
      });
    });
  });
};

export const getMostReadArticles = (interval, offset = 0) => {
  return dispatch => {
    dispatch({
      type: ACTION.MOST_READ_REQUEST,
    });
    let url = `/cm/public/${process.env.REACT_APP_CONTENT_SPACE}/articles/most-popular`;
    if (interval) {
      url = `${url}/${interval}`;
    }
    return Api.get(url, {
      limit: 100,
      offset,
    }).then(response => {
      dispatch({
        type: ACTION.MOST_READ_SUCCESS,
        data: {
          interval,
          articles: response,
        },
        append: offset > 0,
      });
    });
  };
};

export const getHomeArticleFromTvKosice = () => {
  return dispatch => {
    dispatch({
      type: ACTION.HOME_TVKOSICE_ARTICLE_REQUEST,
    });
    return Api.get('/videos/home', {
      limit: 3,
    }).then(response => {
      let videos = getProp(response, 'videos', []);
      // let video = videos.length > 0 ? videos[0] : null;
      dispatch({
        type: ACTION.HOME_TVKOSICE_ARTICLE_SUCCESS,
        data: videos,
      });
    });
  };
};

export const getHomeArticleFromRadioKosice = () => {
  return dispatch => {
    dispatch({
      type: ACTION.HOME_RADIOKOSICE_ARTICLE_REQUEST,
    });
    return Api.get('/cm/public/radiokosice/articles', {
      limit: 3,
    }).then(response => {
      let articles = getProp(response, 'articles', []);
      // let article = articles.length > 0 ? articles[0] : null;
      dispatch({
        type: ACTION.HOME_RADIOKOSICE_ARTICLE_SUCCESS,
        data: articles,
      });
    });
  };
};

export const updateWeatherCredit = credit => {
  return {
    type: ACTION.WEATHER_CREDIT,
    credit,
  };
};

export const getUser = token => {
  return dispatch => {
    const promises = [];
    promises.push(
      Api.get('/oauth2/user').then(response => {
        dispatch({
          type: ACTION.GET_USER,
          data: response,
        });
      }),
    );
    let lastvisit = Cookies.get('last_visit');
    const params = {};
    let since = moment(lastvisit);
    if (lastvisit && since.isValid()) {
      params['since'] = since;
    }
    promises.push(
      Api.get(
        `/cm/public/${process.env.REACT_APP_CONTENT_SPACE}/userfeed/count`,
        params,
      ).then(response => {
        dispatch({
          type: ACTION.UPDATE_UNREAD_ARTICLES,
          data: response.count,
        });
      }),
    );

    return Promise.all(promises);
  };
};

export const logout = () => {
  return dispatch => {
    let token = Cookies.get('token');
    Api.post('/oauth2/revoke', {
      access_token: token,
    });
    Cookies.remove('token');
    dispatch({
      type: ACTION.GET_USER,
      data: null,
    });
  };
};

export const getCalendarLocations = () => {
  return (dispatch, getState) => {
    const locations = getState().calendar.locations;
    if (locations.length > 0) {
      //return Promise.resolve();
    }
    return Api.get('/calendar/locations').then(response => {
      dispatch({
        type: ACTION.FETCH_CALENDAR_LOCATIONS_SUCCESS,
        data: response.locations,
      });
    });
  };
};

export const calendarEventsKey = (locationId, dateStr) => {
  return `${locationId}_${dateStr}`;
};

export const getCalendarEvents = (locationId, date) => {
  return dispatch => {
    const key = calendarEventsKey(locationId, date.format('YYYY-MM-DD'));
    dispatch(addLoading());
    dispatch({
      type: ACTION.FETCH_CALENDAR_EVENTS_REQUEST,
    });
    return Api.get(`/calendar/${locationId}/${date.format('YYYY-MM-DD')}`)
      .then(response => {
        dispatch(removeLoading());
        dispatch({
          type: ACTION.FETCH_CALENDAR_EVENTS_SUCCESS,
          data: {
            events: response.events,
            key,
          },
        });
      })
      .catch(err => {
        dispatch(removeLoading());
        dispatch({
          type: ACTION.FETCH_CALENDAR_EVENTS_FAILURE,
        });
      });
  };
};

export const fetchCalendarStaticText = () => {
  return dispatch => {
    dispatch(
      fetchStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'CALENDAR_STATIC_TEXT',
        'reklamny-text-v-kalendari',
      ),
    );
  };
};

export const fetchCalendarStaticTextAdd = () => {
  return dispatch => {
    dispatch(
      fetchStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'CALENDAR_STATIC_TEXT_ADD',
        'calendar-add-text',
      ),
    );
  };
};

export const fetchBanner = id => {
  return dispatch => {
    Api.get(`/cm/public/kosiceonline/banner/${id}`).then(response => {
      dispatch({
        type: ACTION.BANNER_FETCH_SUCCESS,
        data: {
          id: id,
          data: response,
        },
      });
    });
  };
};

export const fetchElectionStaticData = () => {
  const key = 'ELECTION_STATIC_DATA';
  return async dispatch => {
    try {
      dispatch(xhrRequest(key));
      const data = await Api.get('/election/static-data');
      dispatch(xhrRequestSuccess(key, data));
    } catch (e) {
      console.error(e);
    }
  };
};

export const fetchElectionSlovakiaData = () => {
  const key = 'ELECTION_SLOVAKIA';
  return async dispatch => {
    try {
      dispatch(xhrRequest(key));
      const data = await Api.get('/election/slovakia');      
      dispatch(xhrRequestSuccess(key, data));
    } catch (e) {
      dispatch(xhrRequestFailure(key))
    }
  };
};

export const fetchElectionRegionData = id => {
  const key = 'ELECTION_REGION';
  return async dispatch => {
    try {
      let idCpy = id;
      if (!idCpy) {
        idCpy = 1;
      }
      dispatch(xhrRequest(key));
      const data = await Api.get(`/election/region/${idCpy}`);
      dispatch(xhrRequestSuccess(key, data));
    } catch (e) {
      dispatch(xhrRequestFailure(key))
    }
  };
};

export const fetchElectionDistrictData = id => {
  const key = 'ELECTION_DISTRICT';
  return async dispatch => {
    try {
      let idCpy = id;
      if (!idCpy) {
        idCpy = 101;
      }
      dispatch(xhrRequest(key));
      const data = await Api.get(`/election/district/${idCpy}`);
      dispatch(xhrRequestSuccess(key, data));
    } catch (e) {
      dispatch(xhrRequestFailure(key))
    }
  };
};




// WEBPACK FOOTER //
// ./src/app/actions.js